import { Switch, SwitchInput, SwitchLabel } from '@/styles/buttons';
import React, { useEffect, useState } from 'react';

interface ToggleSwitchProps {
	checked: boolean;
	onToggle?: (checked: boolean) => Promise<boolean>;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onToggle }) => {
	const [isChecked, setIsChecked] = useState(checked);

	useEffect(() => {
		setIsChecked(checked);
	}, [checked]);

	return (
		<SwitchLabel>
			<SwitchInput
				type='checkbox'
				checked={isChecked}
				onChange={async (e) => {
					const value = e.target.checked;
					const result = await onToggle?.(value);
					setIsChecked(result ?? value);
				}}
			/>
			<Switch />
		</SwitchLabel>
	);
};

export default ToggleSwitch;
